import React from 'react';
import styled from 'styled-components';
import { Captions, ShortBody } from 'components/Typography';
import { Grid, Paper } from '@material-ui/core';

export const StyledPaper = styled(({ ...otherProps }) => (
  <Paper {...otherProps} />
))`
  border-radius: 8px !important;
  border-bottom-right-radius: 8px !important;
  padding: 22px !important;
`;
export const StyledCaption = styled(Captions)`
  && {
    color: #838ea4;
    font-size: 13px !important;
    line-height: 18px !important;
    margin: 0;
  }
`;
export const StyledShortBody = styled(({ reverse, ...otherProps }) => (
  <ShortBody {...otherProps} />
))`
  && {
    font-weight: 500;
    margin-bottom: 0;
    font-size: 17px !important;
    line-height: 20px !important;
    text-align: ${(props) => (props.reverse ? 'right' : 'left')}!important;
  }
`;
export const formStyle = {
  infoIcon: {
    cursor: 'pointer',
    height: '20px',
    width: '20px',
    color: '#C2D1D9',
    '&:hover': {
      borderRadius: '50%',
    },
  },
};
export const StyledGridLeft = styled(Grid)`
  margin-left: 3px;
  margin-top: 1px;
`;
